import { useCallback } from 'react';

import upperFirst from 'lodash/upperFirst';

import { type TransactionStatus } from '../../generated/graphql';

export function useFormatTransactionStatus(): (status: TransactionStatus) => string {
  return useCallback((status) => {
    return upperFirst(status);
  }, []);
}
